// src/PrivacyPolicy.js
import React from "react";
import logo from "./logo.svg";

const PrivacyPolicy = ({ appName }) => {
  const privacyPolicyContent = `
歡迎使用 ${appName}（以下簡稱“本應用”）。我們重視您的隱私，並致力於保護您的個人信息。本隱私政策說明了我們如何收集、使用、儲存和保護您的信息。

1. 收集的資料：
   本應用不會收集或儲存您的實際位置信息。當您使用我們的服務查看露營地資訊時，我們會使用我們的資料庫內的露營地經緯度資訊來顯示相關地點於地圖服務中（如 Google Maps）。我們不會向任何第三方提供您的位置資料。

2. 第三方服務：
   - 本應用包含指向外部網站或服務的鏈接，包括 Google Maps 和露營場地的官網。這些網站和服務可能會使用 cookies 或其他追蹤技術來收集您的數據。我們建議您查看這些第三方網站的隱私政策。 

3. 數據安全：
   - 我們採取適當的技術和管理措施來保護您的數據免於未經授權的訪問。

4. 聯繫我們：
   - 如有任何問題或建議，請聯繫我們：otislin1102@gmail.com
`;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        minHeight: "100vh",
        width: "100vw",
        overflowY: "auto",
      }}
    >
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <img src={logo} className="App-logo" alt="logo" />
      </div>
      <div
        style={{ textAlign: "left", padding: "20px", whiteSpace: "pre-wrap" }}
      >
        <h1 className="main-font-color">隱私政策</h1>
        <div className="main-font-color">{privacyPolicyContent}</div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
